import { stats } from "@/mocks/data";

const anchor = (e: React.MouseEvent, href: string) => {
  e.preventDefault();
  document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
};

export default function Hero() {
  return (
    <section
      id="home"
      className="relative overflow-hidden bg-background-50 pt-28 pb-16 md:pt-36 md:pb-24"
    >
      {/* 背景装饰 */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-24 top-16 h-72 w-72 rounded-full bg-secondary-200/50 blur-2xl"
      ></div>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-20 top-40 h-64 w-64 rounded-full bg-primary-100/70 blur-2xl"
      ></div>
      <div
        aria-hidden="true"
        className="animate-floaty pointer-events-none absolute right-[12%] top-24 hidden text-5xl text-primary-400/70 lg:block"
      >
        <i className="ri-water-flash-line"></i>
      </div>
      <div
        aria-hidden="true"
        className="animate-floaty pointer-events-none absolute left-[10%] bottom-24 hidden text-4xl text-secondary-500/70 lg:block"
        style={{ animationDelay: "1.2s" }}
      >
        <i className="ri-news-line"></i>
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full bg-background-100 px-4 py-2 text-sm text-foreground-600 ring-1 ring-background-200">
            <span className="flex h-2 w-2 rounded-full bg-accent-500"></span>
            今日热度持续攀升 · 蹲更新进行中
          </div>
          <h1 className="font-heading text-4xl leading-tight text-foreground-950 md:text-6xl md:leading-tight">
            让吃瓜
            <span className="mx-2 inline-block rotate-3 rounded-2xl bg-primary-100 px-3 text-primary-600">
              成为你的日常
            </span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
            打卡、日常追瓜、蹲更新、定时刷新、睡前必看、通勤速览。
            吃瓜每日把零散的娱乐动态整理成一套可持续的每日习惯,
            不错过任何一条圈内新瓜。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#schedule"
              onClick={(e) => anchor(e, "#schedule")}
              className="w-full whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-all hover:bg-primary-600 sm:w-auto"
            >
              查看每日瓜历
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="#hot"
              onClick={(e) => anchor(e, "#hot")}
              className="w-full whitespace-nowrap rounded-full bg-background-100 px-7 py-3.5 text-sm font-medium text-foreground-800 ring-1 ring-background-300 transition-colors hover:bg-background-200 sm:w-auto"
            >
              <i className="ri-fire-line mr-2 text-accent-500"></i>
              今日热瓜
            </a>
          </div>
        </div>

        {/* 数据条 */}
        <div className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-3 md:mt-20 md:grid-cols-4 md:gap-5">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl bg-background-100/80 px-4 py-5 text-center ring-1 ring-background-200"
            >
              <div className="font-heading text-2xl text-foreground-950 md:text-3xl">
                {s.value}
                <span className="text-lg text-primary-500">{s.suffix}</span>
              </div>
              <div className="mt-1 text-xs text-foreground-500 md:text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}